function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_5776",
  "data-name": "Rectangle 5776",
  d: "M0,0H24V24H0Z",
  fill: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Exclusion_1",
  "data-name": "Exclusion 1",
  d: "M4.822,17a.769.769,0,0,1-.777-.871V13.8H3.723a3.739,3.739,0,0,1-2.735-1A3.839,3.839,0,0,1,0,10.02V3.773A3.439,3.439,0,0,1,3.781,0H14.045a3.439,3.439,0,0,1,3.783,3.773V10.02A3.434,3.434,0,0,1,14.07,13.8H8.764L5.8,16.469A1.449,1.449,0,0,1,4.822,17ZM8.914,4.889a.729.729,0,0,0-.793.781L8,9.91a.851.851,0,0,0,.227.623,1.01,1.01,0,0,0,1.363-.006A.855.855,0,0,0,9.82,9.9L9.686,5.67a.705.705,0,0,0-.772-.781Zm0-2.918a1.011,1.011,0,0,0-1.041.977.994.994,0,0,0,1.041.965.991.991,0,0,0,1.035-.965,1,1,0,0,0-1.035-.977Z",
  transform: "translate(3.088 3.504)",
  fill: "#fff"
});

function SvgInfoBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "info_bubble",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoBubble);
export default __webpack_public_path__ + "static/media/info_bubble.18d5221a.svg";
export { ForwardRef as ReactComponent };